import React from 'react'
import ReturnHeader from './../../components/returnHeader'
import { angelRight, chemistry, videoIcon, commentDots, likeVideo, crypto, player } from '../../assets'
import {fake} from './../../faker'
import { Link } from 'react-router-dom'

const Lessons = ({fileType}) => {
  return (
    <div>
        <ReturnHeader page={'Lessons'}/>
        <div className='flex justify-center mt-[-13px]'>
            <div className='text-gray-lightlyGray ml-[20px]  text-[15px]'>105 Lessons</div>
        </div>
        <div>
            <div className='mt-[30px] flex gap-[16px] w-full flex-wrap'>
            { fake.map((item)=>(

              <div className='flex mx-[30px] w-full justify-between max-w-[344px] sm:max-w-[450px] items-center'>
                <Link to='/about' className='flex items-center  gap-[22px]'>
                <div className='flex justify-center relative items-center rounded-[10px] w-[90px] h-[83px] sm:w-[160] overflow-hidden'>
                    <img className='h-full' src={chemistry} alt="no data" />
                    {
                      fileType==='video' &&
                    <img className='absolute top-[40%] left-[35%] w-[26px] h-[26px]' src={player} alt="" />
                    }
                </div>
                <div>
                    <div className='flex gap-[9px] items-center'>
                        <div className='w-[110px] sm:h-[34px] h-[22px] overflow-hidden relative shadow-whiteShadow'>
                        <div className='text-[18px] w-full whitespace-nowrap absolute font-normal sm:text-[20px]'>{item.name}</div>
                        <div className='h-[50px] absolute right-[0] top-0  w-[60px] shadow-whiteShadow'></div>
                        </div>                            
                        <div className='text-[12px] sm:text-[15px] font-[Poppins] cursor-pointer text-gray-lightlyGray'> Videos</div>
                        <div><img src={videoIcon} alt="" /></div>
                    </div>
                    <div className='text-[10px] sm:text-[14px] gap-[19px] flex items-center  font-[Poppins]'>
                      <div className='flex gap-[5px] items-center'>
                      <img src={likeVideo} alt="" />
                      <div className='text-blue-likeBlue'>785</div>
                      </div> 
                      <div className='flex gap-[5px] items-center'>
                      <img src={crypto} alt="" />
                      <div className='text-gray-lightlyGray'>1k+</div>
                      </div>
                      <div className='flex gap-[5px] items-center'>
                      <img src={commentDots} alt="" />
                      <div className='text-gray-lightlyGray'>850+</div>
                      </div>
                    </div>
                </div>
                </Link>
                <div className='cursor-pointer'><img src={angelRight} alt="" /></div>
              </div>
                ))}

            </div>
        </div>
    </div>
  )
}

export default Lessons